<template>
   <div class="layout-page">
      <h1>Reports</h1>

      <div class="container-fluid">
         <div class="row mart-24 ">
            <div class="col-sm-10">

               <!-- Nav tabs -->
               <ul class="nav nav-tabs">
                  <li class="nav-item">
                     <a class="nav-link active" data-toggle="tab" href="#reports" id="reports_tab">REPORT RESULTS</a>
                  </li>
                  <li class="nav-item">
                     <a class="nav-link" data-toggle="tab" href="#requests" id="requests_tab">REQUEST a REPORT</a>
                  </li>
               </ul>

               <div class="tab-content">
                  <!-- Reports TAB -->
                  <div id="reports" class="tab-pane fade show active">
                     <i class="fas fa-spinner fa-spin ml-orange fa-lg" v-if="loading"></i>
                     <div v-else>
                        <h4 class="marb-12">Previously Requested Reports</h4>

                        <div id="divRpts" class="table-responsive">
                           <table class="table table-condensed table-striped font-smaller">
                              <thead>
                                 <tr>
                                    <th>Request Date</th>
                                    <th>Report</th>
                                    <th>Report Filters</th>
                                    <th>Status</th>
                                 </tr>
                              </thead>
                              <tbody>
                                 <tr v-for="(r) in requests" :key="r.reportRequestId">
                                    <td>{{ longDate(r.requestDt) }}</td>
                                    <td>{{ r.report.name }}</td>
                                    <td class="font-smaller">{{ r.filterText }}</td>
                                    <td>
                                       <a @click.prevent="reportSelected(r)" v-tooltip:left="r.status"
                                          class="status-button">
                                          <i v-if="r.statusCode == 'RPTSTATUS_PENDING'" class="fas fa-clock ml-blue"></i>
                                          <i v-if="r.statusCode == 'RPTSTATUS_STARTED'"
                                             class="fas fa-spinner fa-spin ml-orange"></i>
                                          <i v-if="r.statusCode == 'RPTSTATUS_ERROR'"
                                             class="fas fa-exclamation-triangle text-danger"></i>
                                          <i v-if="r.statusCode == 'RPTSTATUS_COMPLETED'" class="fas fa-download"></i>
                                       </a>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                        </div>
                     </div>
                  </div>

                  <!-- Request TAB -->
                  <div id="requests" class="tab-pane fade">
                     <i class="fas fa-spinner fa-spin ml-orange fa-lg" v-if="loading"></i>
                     <div v-else>
                        <h4 class="marb-12">Request a Report</h4>
                     </div>

                     <div class="row mart-12">
                        <div class="form-group col-6">
                           <label for="exampleFormControlSelect1">Choose a Report:</label>
                           <div class="dropdown">
                              <button class="btn report-ddl dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                 (Choose a Report)
                              </button>
                              <div class="dropdown-menu" id="ddlChildren" aria-labelledby="dropdownMenuButton">
                                 <a class="dropdown-item" href="#" v-for="r in reports" 
                                    :key="r.reportId" :value="r.reportId"
                                    @click.prevent="reportWasSelected(r.reportId, r.name)"
                                 >{{ r.name }}</a>
                              </div>
                           </div>
                        </div>
                        <div class="form-group col-6">
                           <label>&nbsp;</label>
                           <div class="rpt-info">{{ reportInfo() }}</div>
                        </div>
                     </div>

                     <div v-show="selectedReportId != null" class="mart-12">
                        <!-- Render the Report Criteria -->
                        <c-down v-if="selectedReportId == 1" :userId="userId" :reportId="selectedReportId"
                           @rpt-submitted="reportSubmitted"></c-down>
                        <c-recruit v-if="selectedReportId == 2" :userId="userId" :reportId="selectedReportId"
                           @rpt-submitted="reportSubmitted"></c-recruit>
                     </div>
                  </div>
               </div>

            </div>
         </div>
      </div>
   </div>
</template>

<script>
import moment from 'moment'
import $ from "jquery"
import critRptDownline from '@/components/rptcriteria/cRptDown';
import critRptRecruit from '@/components/rptcriteria/cRptRecruitment';

export default {
   name: "reports",
   components: {
      "c-down": critRptDownline,
      "c-recruit": critRptRecruit
   },
   data() {
      return {
         loading: true,
         reports: [],
         requests: [],
         selectedReportId: null,
         userId: this.$store.getters.appUser.userId,
         statusCheckTimer: null
      }
   },
   async mounted() {
      this.$parent.loadingStart()
      this.loading = true;
      await this.initialize()
      await this.loadReports()

      // Set the page up to continue to check the status of reports every 5 seconds
      this.statusCheckTimer = setInterval(async () => {
         await this.loadReports()
      }, 5000)
      this.loading = false;
      this.$parent.loadingEnd()
   },
   beforeDestroy() {
      clearInterval(this.statusCheckTimer)
   },
   methods: {
      async initialize() {
         await this.loadReportDefs()
      },
      async loadReports() {
         await this.$reports.getRequests(this.userId)
            .then(async (item) => {
               this.requests = item
               await this.$store.dispatch("getPendingReports")
            })
            .catch(err => {
               // Dont put up message because a msg every 5 seconds can be annoyong when offline                                
            })

      },
      async loadReportDefs() {
         await this.$reports.getList()
            .then(item => {
               this.reports = item
            })
            .catch(err => {
               this.$swal(
                  "Oops!",
                  "An error occured on loading the page. Please try again later or contact support if the problem persists.",
                  "error"
               )
            })
      },
      reportInfo() {
         if (this.selectedReportId == "") return ""
         let rpt = this.reports.find(r => r.reportId == this.selectedReportId);
         if (rpt) {
            return rpt.info
         }
         return ""
      },
      reportWasSelected(id, name) {
         let btn = document.getElementById('dropdownMenuButton')
         btn.innerText = name
         this.selectedReportId = id
      },
      async reportSelected(req) {
         switch (req.statusCode) {
            case 'RPTSTATUS_PENDING':
               this.$swal(
                  "Request Pending",
                  "Your requested report has been queued up but has not been started yet. The length of time it takes depends the reports that are in line ahead of it.",
                  "info"
               )
               break;
            case 'RPTSTATUS_STARTED':
               this.$swal(
                  "Request Started",
                  "The requested report has started executing. The length of time it takes depends on the report and the amount of data you have.",
                  "info"
               )
               break;
            case 'RPTSTATUS_ERROR':
               if (req.errorMessage.includes("NO DATA")) {
                  this.$swal(
                     "No Results",
                     "Your requested report ended without finding any data associated with the report filters or the user. Please try again with different filters or contact support if the problem persists.",
                     "error"
                  )
               } else {
                  this.$swal(
                     "Oops!",
                     "Your requested report ended in an error and was aborted. Its possible that there was no data associated with the user or the report filters. Please try again later or contact support if the problem persists.",
                     "error"
                  )
               }
               break;
            case 'RPTSTATUS_COMPLETED':
               await this.openDoc(req.outputPath, req.report.name)
               break;
         }
      },
      async openDoc(doc, ttl) {
         let title = ttl.replace(/ /g, "_");
         let payload = {
            AppUserId: this.userId,
            DownloadFileType: 5, // ExcelReport
            Path: doc,
            Title: title + ".xlsx",
         };

         this.$swal({
            title: "Download Initiated",
            html: "Please wait...",
            timer: 1000,
            timerProgressBar: true,
            showCancelButton: false,
            showConfirmButton: false,
            willOpen: () => {
               this.$swal.showLoading();
            },
            willClose: () => { },
         });

         this.$document.apiDownload(payload).then(
            (r) => {
               if (this.$document.errors.length > 0) {
                  this.$swal(
                     "Document Unavailable",
                     "Unfortunately we are having trouble downloading your document at this time. Please try again later or contact us if this problem persists.",
                     "error"
                  );
               } 
            },
            (e) => {
               this.$swal(
                  "Document Unavailable",
                  "Unfortunately we are having trouble downloading your document at this time. Please try again later or contact us if this problem persists.",
                  "error"
               );
            }
         );
      },
      longDate(dt) {
         return moment(String(dt), moment.ISO_8601).format('MM/DD/YYYY hh:mm')
      },
      activate(tab) {
         $('.nav-tabs a[href="#' + tab + '"]').tab('show');
      },
      reportSubmitted() {
         this.activate('reports')
      }
   }
}
</script>

<style lang="scss">
@import "../assets/css/colors.scss";

.tab-content {
   padding: 24px;
   min-height: 475px;
   margin-bottom: 24px;
}

.instructions {
   color: $corp-purple;
}

h4 {
   color: $corp-orange;
}

.rpt-info {
   color: $corp-color;
   margin-left: 30px;
   font-size: smaller;
}

.status-button {
   cursor: pointer;
}
.report-ddl, .report-ddl:focus {
   background-color: $corp-color;
   border: 1px solid $corp-color;
   border-radius: 4px;
   color: #fff;
   width: 100%;
   outline: none !important;
   text-align: left;
   font-size: 1em;
}
#ddlChildren {
   width: 100%;
   border-left: 1px solid $corp-color;
   border-right: 1px solid $corp-color;
   border-bottom: 1px solid $corp-color;
   box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
   font-size: 1em;
}
#ddlChildren a {
   color: #000;
}
</style>